import { render } from "./SecuritySettings.vue?vue&type=template&id=07744d28&scoped=true"
import script from "./SecuritySettings.vue?vue&type=script&lang=js"
export * from "./SecuritySettings.vue?vue&type=script&lang=js"

import "./SecuritySettings.vue?vue&type=style&index=0&id=07744d28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07744d28"]])

export default __exports__